import React from 'react';

const Loading = () => {
  return (
    <div className="fixed inset-0 bg-dark-bg flex items-center justify-center p-6 z-50" role="status" aria-live="polite">
      <div className="text-center">
        <div className="relative inline-block" aria-hidden="true">
          <div className="w-16 h-16 border-4 border-snipehouse-blue/30 border-t-snipehouse-blue rounded-full animate-spin"></div>
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-8 h-8 bg-snipehouse-blue/20 rounded-full animate-pulse"></div>
          </div>
        </div>
        <p className="mt-4 text-gray-400 font-medium">Loading...</p>
      </div>
    </div>
  );
};

export default React.memo(Loading);
